// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import UpdateContactIdMappingRequestModel from '../../model/update-contact-id-mapping-request-model';
import UpdateContactIdMappingRequestDTO from '../dto/update-contact-id-mapping-request-dto';
import dtoSchema from '../schemas/update-contact-id-mapping-request-schema';

export default abstract class UpdateContactIdMappingRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<UpdateContactIdMappingRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<UpdateContactIdMappingRequestDTO>): UpdateContactIdMappingRequestModel;
  static toModel(dto: DeepPartial<UpdateContactIdMappingRequestDTO> | undefined | null): UpdateContactIdMappingRequestModel | undefined;
  static toModel(dto: DeepPartial<UpdateContactIdMappingRequestDTO> | undefined | null): UpdateContactIdMappingRequestModel | undefined {
    return dto ? new UpdateContactIdMappingRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<UpdateContactIdMappingRequestModel> | UpdateContactIdMappingRequestModel): UpdateContactIdMappingRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as UpdateContactIdMappingRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for UpdateContactIdMappingRequestModel, can not map to UpdateContactIdMappingRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
